$(function(){

  
  $(window).on('load scroll', function() {
     var winScroll = $(window).scrollTop();
     var winHeight = $(window).height();
     var scrollPos = winScroll + (winHeight * 0.8);

     $(".show").each(function() {
        if($(this).offset().top < scrollPos) {
           $(this).css({opacity: 1, transform: 'translate(0, 0)'});
        }
     });
  });
});

document.addEventListener("DOMContentLoaded", function () {
   var spMenu = document.querySelector('.sp_menu');
   var header = document.querySelector('.yokan-heaer');
   spMenu.addEventListener('click', function () {
     header.classList.toggle('on');
   });
 });

 document.addEventListener("DOMContentLoaded", function () {
   var headerNav = document.querySelector('.header_nav');
   var header = document.querySelector('.yokan-heaer');
   headerNav.addEventListener('click', function (e) {
     if (e.target.closest('.on')) {
       header.classList.remove('on');
     }
   });
 });

document.addEventListener("DOMContentLoaded", function () {
  var headerNavs = document.querySelectorAll('.header_nav');
  var header = document.querySelector('.yokan-heaer');

  headerNavs.forEach(function(headerNav) {
    headerNav.addEventListener('click', function (e) {
      if (e.target.closest('.on')) {
        header.classList.remove('on');
      }
    });
  });
});

 const headerHeight = document.querySelector('.yokan-heaer').offsetHeight;

//querySelectorAllメソッドを使用してページ内のhref属性が#で始まるものを選択
//forEachメソッドを使って、各アンカータグにクリックされた時の処理
/*
document.querySelectorAll('a[href^="#"], area[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {

    // クリックされたときのデフォルトの挙動を防ぐ
    e.preventDefault();

    // クリックされたアンカータグのhref属性を取得
    const href = anchor.getAttribute('href');

    // href属性の#を取り除いた部分と一致するIDを取得
    const target = document.getElementById(href.replace('#', ''));

    //取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
    //headerの高さを引いて、スクロール位置がヘッダーの下になるように調整します。
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    // window.scrollTo()を呼び出して、スクロール位置を設定します。behaviorオプションをsmoothに設定することで、スムーズなスクロールを実現します。
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
  });
});
*/

document.querySelectorAll('a[href^="#"], area[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    // クリックされたときのデフォルトの挙動を防ぐ
    e.preventDefault();

    // onクラスを削除する
    var header = document.querySelector('.yokan-heaer');
    header.classList.remove('on');

    // クリックされたアンカータグのhref属性を取得
    const href = anchor.getAttribute('href');

    // href属性の#を取り除いた部分と一致するIDを取得
    const target = document.getElementById(href.replace('#', ''));

    //取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
    //headerの高さを引いて、スクロール位置がヘッダーの下になるように調整します。
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    // window.scrollTo()を呼び出して、スクロール位置を設定します。behaviorオプションをsmoothに設定することで、スムーズなスクロールを実現します。
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
  });
});